import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import ResetPassword from './resetPassword/resetPassword';
import Registration from './registration/Registration';
import PersonalData from './personalData/PersonalData';
import Auth from './auth/Auth';
import Logout from './Logout/Logout';
import User from './user/User';
import { errorHelper, messageHelper } from './helper.js';

import {
  AUTH_URL, INDIVIDUAL_URL,
  FILE_POST_URL,
  REFERENCES_URL,
  USER_LIST_URL,
  DOMEN,
  GET_LIST_USER_MEETING_URL,
  GET_USER_MEETING_REG_URL,
  MAKE_REGISTRATION_URL,
  MAKE_SPEECH_REGISTRATION_URL,
  MAKE_GLOBAL_REGISTRATION_URL,
  SCHOOL_REGISTRATION_URL,
  GET_SPEECH_REGISTRATION_URL,
  ADD_THESIS_FILE_URL,
  CHANGE_REGISTRATION_URL,
  CHANGE_REGISTRATION_GLOBAL_URL,
  CHANGE_SP_REGISTRATION_URL,
  EXPORT_USER_LIST_TO_EXCEL_URL,
  MAKE_INVITE_URL,
  MAKE_SERT_URL,
  GET_ATTENDANCE_LIST_URL,
  LOAD_EMAIL_LIST_URL,
} from '../../vars';

Vue.use(Vuex);

/**
 * @namespace Main
 */
export default new Vuex.Store({
  state: {
    isLoggedIn: '',
    nameUser: '',
    individual: null,
    scientIfic: null,
    profile: null,
    overlay: false,
    organizations: [],
    organizationsAlpha: [],     
  },
  mutations: {
    UPDATE_OVERLAY(state, data) {
      state.overlay = data;
    },
    UPDATE_NAME_USER(state, data) {
      state.nameUser = data;
    },
    SET_IS_LOGGED_IN(state, payload) {
      state.isLoggedIn = payload.id;
    },
    UPDATE_INDIVIDUAL(state, data) {
      state.individual = data.data;
    },

    UPDATE_PROFILE(state, data) {
      state.profile = data;
    },

    UPDATE_ORGS(state, organizations) {
      // console.log('UPDATE_ORGS', organizations);
      state.organizationsAlpha = organizations;
      organizations.forEach(item => {
          state.organizations[item.id] = item
      })

    },

  },

  actions: {
    async logged(ctx, payload) {
      if (payload.token) {
        try {
          // console.log('payload ---> ', payload);
          axios.get(`${AUTH_URL}profile/`, {
            headers: {
              Authorization: `Token ${payload.token}`,
            },
          })
            .then((res) => {
              ctx.commit('SET_IS_LOGGED_IN', { id: res.data.id });
              ctx.commit('UPDATE_ISLOGGEG', true); 
            })
            .catch((e) => {
              errorHelper(e);
              messageHelper(e.response.data.detail, 'error', 6000, e);
            });
        } catch (ex) {
          console.log('ex store logged ---> ', ex);
          messageHelper(ex.response.data.detail, 'error', 6000, ex);
        }
      }
    },
    // /////

    /**
     * Получает данные о пользователе и записывает
     * @param {Object} ctx
     * @param {Number|String} id Идентификатор профиля
     * @throws {Object} Ошибка получения данных
     *
     * @memberof Main
     */
    async GET_PROFILE(ctx, id) {
      if (id) {
        try {
          const res = await axios.get(`${AUTH_URL}profile/?id=${id}`, {
            headers: {
              Authorization: `Token ${localStorage.token}`,
            },
          });

          await ctx.commit('UPDATE_PROFILE', res);
          await ctx.commit('SET_IS_LOGGED_IN', res.data);
        } catch (e) {
          if (e.response.data.detail !== 'Недопустимый токен.') {
            errorHelper(e);
            messageHelper('', 'error', 6000, e);
            throw e;
          }
        }
      }
    },


    /**
     * export to excel
     * @param {Object} ctx
     * @param {Array|Object} data список идентификаторов
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async UPLOAD_LIST_TO_EXCEL(ctx, data) {
      try {
        const res = await axios.get(`${EXPORT_USER_LIST_TO_EXCEL_URL}?type_filter=${data}`, {
        // const res = await axios.get(`${EXPORT_USER_LIST_TO_EXCEL_URL}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return {url: `${DOMEN}${res.data.url}`};
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, ' erer');
        throw e;
      }
    },

    /**
     * Получает список данных по ролям(moderator)
     * @param {Object} ctx 
     * @param {Object} data Данные для получания списка по ролям
     * @returns {Object} Данные резьтатат запроса
     * @throws {Object} Ошибка запроса данных
     * 
     * @memberof RoleList
     */
    async GET_LIST_USER_MEETING(ctx, data) {
      try {
        const res = await axios.get(`${GET_LIST_USER_MEETING_URL}?meeting_id=${data['meeting_id']}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res.data
      } catch(e) {
          errorHelper(e)
          messageHelper('', 'error', 6000, e)
          throw e
      }
  },


    /**
     *
     * @param {Object} ctx
     * @param {String} data Фамилия для поиска
     */
    async GET_TEAM_INDIVIDUAL(ctx, data) {
      try {
        const res = await axios.get(`${INDIVIDUAL_URL}=${data}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });

        await ctx.commit('UPDATE_INDIVIDUAL', res);
        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e;
      }
    },

    /**
     * Отправляет файл
     * @param {Object} ctx
     * @param {Object} data Данные для отправки файла
     * @returns {Object} Результат записис файла
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async FILE_SEND(ctx, data) {
      try {
        const res = await axios.post(FILE_POST_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e;
      }
    },

    /**
     * Удаляет файл
     * @param {Object} ctx
     * @param {String|Number} data Идентификатор
     * @returns {Object} Результат удаления файла
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     */
    async DELETE_FILE_SYNC(ctx, data) {
      try {
        const res = await axios.delete(`${FILE_POST_URL}?id=${data}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('qwe', e);
        throw e;
      }
    },


    /**
     * Получает список организаций по языку
     * @param {Object} ctx
     * @param {String} data Язык
     * @returns {object} Список организаций
     * @throws {Object} Ошибка запроса данных
     *
     * @memberof Main
     *
     */
    async ORGANIZATION(ctx, data) {
      try {
        const res = await axios.get(`${REFERENCES_URL}organization/list/`);

        await ctx.commit('UPDATE_ORGS', res.data);

        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
      }
    },

    
    async GET_USER_SITE_REG(ctx, data) {
      try {
        const res = await axios.get(`${GET_USER_MEETING_REG_URL}?meeting_id=3`, { 
          headers: {
            Authorization: `Token ${localStorage.token}`
        }});
        return res.data
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e
      }
    },

    async GET_USER_GLOBAL_REG(ctx, data) {
      try {
        const res = await axios.get(`${MAKE_GLOBAL_REGISTRATION_URL}?meeting_id=3`, { 
          headers: {
            Authorization: `Token ${localStorage.token}`
        }});
        return res.data
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e
      }
    },

    
    async GET_USER_SCHOOL_REG(ctx, data) {
      try {
        const res = await axios.get(`${SCHOOL_REGISTRATION_URL}?user_meeting_global_id=${data}`, { 
          headers: {
            Authorization: `Token ${localStorage.token}`
        }});
        return res.data
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        throw e
      }
    },

    async MAKE_SCHOOL_REGISTRATION(ctx, data) {
      try {
        const res = await axios.post(SCHOOL_REGISTRATION_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('MAKE_SCHOOL_REGISTRATION', e);
        return {'data' : {'error' : e.message}}
        // throw e;
      }
    },

    async GET_USER_SPEECH_REG(ctx, data) {
      try {
        const res = await axios.post(GET_SPEECH_REGISTRATION_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res.data;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('GET_USER_SPEECH_REG', e);
        return {'data' : {'error' : e.message}}
        // throw e;
      }
    },

    async ADD_THESIS_FILE(ctx, data) {
      try {
        const res = await axios.post(ADD_THESIS_FILE_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('ADD_THESIS_FILE', e);
        return {'data' : {'error' : e.message}}
        // throw e;
      }
    },

    async CHANGE_REGISTRATION_GLOBAL(ctx, data) {
      try {
        const res = await axios.post(CHANGE_REGISTRATION_GLOBAL_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('CHANGE_REGISTRATION_GLOBAL', e);
        return {'data' : {'error' : e.message}}
        // throw e;
      }
    },
    
    async CHANGE_SP_REGISTRATION(ctx, data) {
      try {
        const res = await axios.post(CHANGE_SP_REGISTRATION_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('CHANGE_SP_REGISTRATION', e);
        return {'data' : {'error' : e.message}}
        // throw e;
      }
    },

    async CHANGE_REGISTRATION(ctx, data) {
      try {
        const res = await axios.post(CHANGE_REGISTRATION_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('CHANGE_REGISTRATION', e);
        return {'data' : {'error' : e.message}}
        // throw e;
      }
    },
    
    async MAKE_GLOBAL_REGISTRATION(ctx, data) {
      try {
        const res = await axios.post(MAKE_GLOBAL_REGISTRATION_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('MAKE_GLOBAL_REGISTRATION', e);
        return {'data' : {'error' : e.message}}
        // throw e;
      }
    },


    async MAKE_SPEECH_REGISTRATION(ctx, data) {
      try {
        const res = await axios.post(MAKE_SPEECH_REGISTRATION_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('MAKE_SPEECH_REGISTRATION', e);
        return {'data' : {'error' : e.message}}
        // throw e;
      }
    },

    async MAKE_REGISTRATION(ctx, data) {
      try {
        const res = await axios.post(MAKE_REGISTRATION_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log('MAKE_REGISTRATION', e);
        return {'data' : {'error' : e.message}}
        // throw e;
      }
    },

    async MAKE_INVITE(ctx, data) {
      try {
        // console.log('MAKE_INVITE', data)
        const res = await axios.get(`${MAKE_INVITE_URL}?type=${data['type']}&id=${data['id']}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        console.log(`${DOMEN}${res.data.url}`);
        await window.open(`${DOMEN}${res.data.url}`, '_blank');
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, ' erer');
        throw e;
      }
    },

    async MAKE_SERT(ctx, data) {
      try {
        const res = await axios.get(`${MAKE_SERT_URL}?id=${data}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        console.log(`${DOMEN}${res.data.url}`);
        await window.open(`${DOMEN}${res.data.url}`, '_blank');
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, ' erer');
        throw e;
      }
    },

    async GET_ATTENDANCE_LIST(ctx, data) {
      try {
        const res = await axios.post(GET_ATTENDANCE_LIST_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res.data;
      } catch(e) {
          errorHelper(e)
          messageHelper('', 'error', 6000, e)
          throw e
      }
    },

    async GET_ATTENDANCE_EXCEL_LIST(ctx, data) {
      try {
        const res = await axios.get(`${GET_ATTENDANCE_LIST_URL}?section_id=${data['section_id']}&type=${data['type']}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return {url: `${DOMEN}${res.data.url}`};
      } catch(e) {
          errorHelper(e)
          messageHelper('', 'error', 6000, e)
          throw e
      }
    },

    async LOAD_EMAIL_LIST(ctx, data) {
      try {
        const res = await axios.post(LOAD_EMAIL_LIST_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`
          }
        })
        return res.data
      } catch (e) {

        errorHelper(e)
        messageHelper(e.response.data.message, 'error', 6000, e)
        throw e
      }
    },


  },

  getters: {
    GETTERS_LOGIN(state) {
      return state.isLoggedIn;
    },
    GETTERS_INDIVIDUAL(state) {
      return state.individual;
    },
    GETTERS_SCIENTIFIC(state) {
      return state.scientIfic;
    },
    GETTERS_NAME_USER(state) {
      return state.nameUser;
    },
    GETTERS_PROFILE(state) {
      return state.profile;
    },
    GETTERS_OVERLAY(state) {
      return state.overlay;
    },
         
    GETTERS_ORG_BY_ID: (state) => (id) => {
      return state.stations[id]
    },
     
    GETTERS_ORGS(state) {
      return state.organizations
    },
    GETTERS_ORGS_ALPHA(state) {
      return state.organizationsAlpha
    },

  },
  modules: {
    ResetPassword,
    Registration,
    PersonalData,
    Auth,
    User,
    Logout,
  },
});
